/** Civic step options for create-post attachment (aligned with mobile). */
export const ACTION_TYPE_OPTIONS = [
  { value: "called_rep", label: "Called my representative" },
  { value: "emailed_rep", label: "Emailed my representative" },
  { value: "submitted_comment", label: "Submitted a public comment" },
  { value: "volunteered", label: "Volunteering" },
  { value: "attended_event", label: "Attended an event" },
  { value: "attended_hearing", label: "Attended a hearing" },
  { value: "signed_petition", label: "Signed a petition" },
  { value: "registered_voters", label: "Registered voters" },
  { value: "other", label: "Other" },
];

const LEGACY_ACTION_TYPE_LABELS = {
  called: "Called my representative",
  emailed: "Emailed my representative",
  met: "Met with rep",
  testified: "Testified",
  petitioned: "Signed a petition",
};

export function formatActionTypeLabel(actionType) {
  if (!actionType) return null;
  const match = ACTION_TYPE_OPTIONS.find((o) => o.value === actionType);
  if (match) return match.label;
  if (LEGACY_ACTION_TYPE_LABELS[actionType]) return LEGACY_ACTION_TYPE_LABELS[actionType];
  return actionType
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
